import { render, staticRenderFns } from "./AccreditationsListContainer.vue?vue&type=template&id=b804f9a0&scoped=true"
import script from "./AccreditationsListContainer.vue?vue&type=script&lang=js"
export * from "./AccreditationsListContainer.vue?vue&type=script&lang=js"
import style0 from "./AccreditationsListContainer.vue?vue&type=style&index=0&id=b804f9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b804f9a0",
  null
  
)

export default component.exports